import {
  IndexTable,
  Layout,
  LegacyCard,
  EmptySearchResult,
  Banner,
} from "@shopify/polaris";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { pullLogsApi } from "../../../redux/troubleshooting/pullLogs/Action";
import { useNavigate, useParams } from "react-router-dom";
import { HistoricalSkeletonTable } from "../../../components/skeletonLoader";
import {
  displayDateTime,
  displayText,
  ReadOnlyTablePagination,
  SUPPORT_TABLE_PAGE_SIZE,
} from "./readOnlyTable";

const PullLogs = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const routeShopId = String(id ?? "");
  const [pagination, setPagination] = useState({
    shopId: routeShopId,
    pageNumber: 0,
  });
  const pageNumber =
    pagination.shopId === routeShopId ? pagination.pageNumber : 0;

  const dispatch = useDispatch();

  const pullLogsData = useSelector((store) => store.requriedPullLogData);
  const isCurrentStore = pullLogsData.shopId === String(id);
  const row =
    isCurrentStore &&
    pullLogsData.isSuccess &&
    Array.isArray(pullLogsData.data?.content)
      ? pullLogsData.data.content
      : [];
  const readError =
    isCurrentStore && pullLogsData.isError ? pullLogsData.error : null;
  const isLoading = !isCurrentStore || pullLogsData.isRequest;

  useEffect(() => {
    const payload = {
      storeId: id,
      pageNumber,
      pageSize: SUPPORT_TABLE_PAGE_SIZE,
    };
    dispatch(pullLogsApi(payload));
  }, [dispatch, id, pageNumber]);

  useEffect(() => {
    if (
      isCurrentStore &&
      (pullLogsData?.data?.message === "Actual error message" ||
        pullLogsData.error === "Actual error message")
    ) {
      navigate("/logout");
    }
  }, [isCurrentStore, navigate, pullLogsData.data, pullLogsData.error]);

  const emptyStateMarkup = (
    <EmptySearchResult
      title="No pull logs found"
      description="No pull activity was returned for this page."
      withIllustration
    />
  );

  const rowMarkup = row.map(
    (
      {
        id: pullLogId,
        reportType,
        loggedAt,
        startedAt,
        completedAt,
        lastCompletedAt,
        report,
      },
      index
    ) => {
      const rowId = String(pullLogId ?? `${loggedAt || "pull-log"}-${index}`);
      return (
        <IndexTable.Row id={rowId} key={rowId} position={index}>
          <IndexTable.Cell>{displayText(reportType)}</IndexTable.Cell>
          <IndexTable.Cell>{displayDateTime(loggedAt)}</IndexTable.Cell>
          <IndexTable.Cell>
            <p>Started: {displayDateTime(startedAt)}</p>
            <p>Completed: {displayDateTime(completedAt)}</p>
            <p>Previous completion: {displayDateTime(lastCompletedAt)}</p>
          </IndexTable.Cell>
          <IndexTable.Cell>
            <p style={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>
              {displayText(report, "No report recorded")}
            </p>
          </IndexTable.Cell>
        </IndexTable.Row>
      );
    }
  );
  const resourceName = {
    singular: "Pull log",
    plural: "Pull logs",
  };
  const pullLogs = (
    <span className="d-flex gap-10">
      <span className="table_heading">Logged at</span>
    </span>
  );
  const handlePageChange = (nextPage) =>
    setPagination({ shopId: routeShopId, pageNumber: nextPage });
  const report = (
    <span className="d-flex gap-10">
      <span className="table_heading">Report</span>
    </span>
  );


  return (
    <Layout.Section>
      <div className="wrapper">
        <LegacyCard sectioned>
          <p className="card_title" style={{ padding: "15px" }}>
            Pull logs
          </p>
          <LegacyCard sectioned>
            {isLoading ? (
              <HistoricalSkeletonTable />
            ) : readError ? (
              <Banner title="Pull logs could not be loaded" status="critical">
                <p>{readError}</p>
              </Banner>
            ) : (
              <IndexTable
                resourceName={resourceName || 0}
                itemCount={row.length}
                emptyState={emptyStateMarkup}
                headings={[
                  { id: "1", title: "Type" },
                  { id: "2", title: pullLogs },
                  { id: "3", title: "Processing window" },
                  { id: "4", title: report },
                ]}
                selectable={false}
              >
                {rowMarkup}
              </IndexTable>
            )}
            {!isLoading && !readError ? (
              <ReadOnlyTablePagination
                response={pullLogsData.data}
                currentPage={pageNumber}
                rowCount={row.length}
                noun="pull log"
                onPageChange={handlePageChange}
              />
            ) : null}
          </LegacyCard>
        </LegacyCard>
      </div>
    </Layout.Section>
  );
  };
export default PullLogs;
